import React from "react";

interface ProgramOfferingsProps {
  content: any;
}

const ProgramOfferings: React.FC<ProgramOfferingsProps> = ({ content }) => {
  const { title, subtitle, benefits } = content;
  return (
    <section className="px-4">
      <h2 className={`text-primary text-3xl font-bold`}>{title}</h2>
      <h3 className="text-xl font-bold py-8">{subtitle}</h3>
      <div className="flex flex-col gap-4">
        {benefits?.map((offering: any, index: number) => (
          <div
            key={`prostate-care-offerings-${index}`}
            className="flex flex-col gap-2"
          >
            <img src={offering.image} alt={offering.title} />
            <h4 className="text-xl font-bold">{offering.title}</h4>
            <p className="text-base font-thin">{offering.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProgramOfferings;
